import React from 'preact';

export default function FontFamily() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="1.5 2 20 17.32">
      <g id="Font">
        <g id="Layer_1-2">
          <path id="Vector" d="M1.76969 19.3153H4.12948C4.24594 19.3153 4.35014 19.2418 4.38691 19.1253L5.87634 14.5222H11.9566L13.4338 19.1253C13.4706 19.2356 13.5748 19.3153 13.6912 19.3153H16.1614C16.1614 19.3153 16.2226 19.3153 16.2472 19.3031C16.2778 19.2908 16.3146 19.2724 16.3391 19.2479C16.3636 19.2234 16.3881 19.1927 16.4004 19.1621C16.4188 19.1314 16.4249 19.0947 16.4249 19.0579C16.4249 19.0211 16.4249 18.9843 16.4127 18.9537L10.645 2.18385C10.6266 2.12869 10.5898 2.08578 10.5469 2.05514C10.504 2.02449 10.4488 2.0061 10.3875 2.0061H7.54965C7.43319 2.0061 7.32899 2.07966 7.29221 2.18998L1.51226 18.9537C1.51226 18.9537 1.5 19.015 1.5 19.0456C1.5 19.1927 1.61646 19.3153 1.76969 19.3153ZM8.86745 4.99109H8.98391L11.3069 12.3095H6.51992L8.86745 4.99109Z" />
          <path id="Vector_2" d="M21.5 2H17.5588V2.60067H21.5V2Z" />
          <path id="Vector_3" d="M21.5 18.7146H17.5588V19.3153H21.5V18.7146Z" />
          <path id="Vector_4" d="M19.8328 2.30029H19.2199V19.3153H19.8328V2.30029Z" />
        </g>
      </g>
    </svg>
  );
}